import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  Button,
  Card,
  Heading,
  Input,
  Label,
  // @ts-ignore
  LabeledInput,
  // @ts-ignore
  List,
  Page,
  PageContent,
  Spacer,
  Text,
} from '@zillow/constellation';
import Helmet from 'react-helmet';

type SocketMessage = {
  from: 'server' | 'client';
  text: string;
};

const socketTypes: { [key: number]: string } = {
  0: 'connecting',
  1: 'open',
  2: 'closing',
  3: 'closed',
};

const LightText = styled(Text)`
  color: ${(props) => props.theme.constellation.colors.textLight};
`;

const WebSocketPage = () => {
  const [socket, setSocket] = useState<WebSocket>();
  const [url, setUrl] = useState('');
  const [socketStatus, setSocketStatus] = useState('closed');
  const [sendMessageText, setSendMessageText] = useState('');
  const [socketMessages, setSocketMessages] = useState<Array<SocketMessage>>([]);

  useEffect(() => {
    // set the default url
    setUrl(`ws://${window.location.host}/rental-manager/growth/proxy-ws-test/hotpads-api/ws/echo`);
  }, []);

  const send = (message: string) => {
    if (socket) {
      const newMessage: SocketMessage = {
        from: 'client',
        text: message,
      };

      setSocketMessages((oldMessages) => {
        return [...oldMessages, ...[newMessage]];
      });

      socket.send(message);
      setSendMessageText('');
    }
  };

  const openWebsocket = () => {
    const client = new WebSocket(url);

    setSocket(client);

    console.log('adding listeners... to:', url);

    client.addEventListener('open', (...args) => {
      setSocketStatus(socketTypes[client.readyState]);
      console.log('socket: on open', ...args);
      client.send('test');
    });

    client.addEventListener('close', (...args) => {
      setSocketStatus(socketTypes[client.readyState]);
      console.log('socket: on close', ...args);
    });

    client.addEventListener('error', (...args) => {
      setSocketStatus(socketTypes[client.readyState]);
      console.log('socket: on error', ...args);
    });

    client.addEventListener('message', (event: MessageEvent) => {
      const newMessage: SocketMessage = {
        from: 'server',
        text: event.data,
      };

      setSocketMessages((oldMessages) => {
        return [...oldMessages, ...[newMessage]];
      });

      console.log('socket: on message', event);
    });
  };

  const toggleSocket = () => {
    if (socket) {
      socket.close();
      setSocketStatus(socketTypes[3]);
      setSocket(undefined);
    } else {
      setSocketStatus(socketTypes[0]);
      openWebsocket();
    }
  };

  const canSendMessage = socket && socket.readyState === 1;

  return (
    <Page>
      <Helmet
        meta={[
          {
            name: 'robots',
            content: 'noindex, nofollow',
          },
        ]}
      />
      <PageContent
        // @ts-ignore
        paddingX="xl"
      >
        <Heading level={2}>Websocket Test Page</Heading>
        <Spacer marginY={4} />
        <Text as="strong">websocket is:</Text> <Text>{socketStatus}</Text>
        <Spacer marginY={4} />
        <LabeledInput
          label={<Label>connection url</Label>}
          input={<Input value={url} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUrl(e.target.value)} />}
        />
        <Button marginY={2} buttonType="primary" onClick={toggleSocket}>
          {socket ? 'end' : 'open'}
        </Button>
        <Spacer marginY={6} />
        <Card>
          {socketMessages.length > 0 ? (
            <List>
              {socketMessages.map((message, idx) => {
                return (
                  <List.Item key={`socket-message-${idx}`}>
                    <Text as="strong">{message.from}:</Text> <Text>{message.text}</Text>
                  </List.Item>
                );
              })}
            </List>
          ) : (
            <LightText>...</LightText>
          )}
        </Card>
        <Spacer marginY={2} />
        <LabeledInput
          style={{ width: '100%' }}
          label={<Label>message</Label>}
          input={
            <Input
              disabled={!canSendMessage}
              value={sendMessageText}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSendMessageText(e.target.value)}
            />
          }
        />
        <Button marginY={2} disabled={!canSendMessage} buttonType="primary" onClick={() => send(sendMessageText)}>
          send
        </Button>
        <Spacer marginY={4} />
      </PageContent>
    </Page>
  );
};

export default WebSocketPage;
